import { render, staticRenderFns } from "./unableplat.vue?vue&type=template&id=72efc0a6&scoped=true&"
import script from "./unableplat.vue?vue&type=script&lang=js&"
export * from "./unableplat.vue?vue&type=script&lang=js&"
import style0 from "./unableplat.vue?vue&type=style&index=0&id=72efc0a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72efc0a6",
  null
  
)

export default component.exports